import React, {Component} from 'react';
import { connect } from 'react-redux';
import imgProfile from '../../../FO/resources/img/user-icon.png';
import { API_URL } from "../../../SHARED/config/apiEndpoints";
import Comment from "../comments/container/comment.component";
import AddCommentForm from '../comments/addcommentForm';
import StarRatingComponent from 'react-star-rating-component';
import { sendMovieReview } from '../../actions/movies.actions';
import { isEmpty } from '../../helpers/general.helper';
import { LOGIN_ROUTE } from '../../config/routes';
import {withRouter} from 'react-router';

import Parser from 'html-react-parser';

class RatingComments extends Component{
    constructor(props){
        super(props);
        this.state = {
            rating: 0,
            movieId: this.props.movieId,
            error: ""
        };
    }

    componentWillReceiveProps(nextProps){
        if (this.props.rating !== nextProps.rating){
            if (nextProps.rating.length > 0){
                this.setState({rating: nextProps.rating[0].review_rating});
            }
        }
        if (this.props.movieId !== nextProps.movieId){
            this.setState({movieId: nextProps.movieId});
            if (nextProps.rating.length > 0){
                this.setState({rating: nextProps.rating[0].review_rating});
            }
        }
    }

    isUserAuthenticated = () => {
        return localStorage.getItem('login_type') === 'authenticated' ? true : false;
    };

    getComment = () => {
        if (this.props.comments){  
            if (this.props.comments.length !== 0){ 
                return this.props.comments.map( (comment, i) => {
                    return <Comment 
                        key={i}
                        image = {comment.comment_author_image ? API_URL + Parser(comment.comment_author_image) : imgProfile}
                        date = {comment.comment_created}
                        name = {comment.comment_author_first_name + " " + comment.comment_author_last_name} 
                        text = {comment.comment_text}
                        />
                    }
                );
            }
            else {
                return <p className="text-white no-comments">Nu exista nici un comentariu adăugat</p>
            }
        }
    }

    onStarClick(nextValue, prevValue, name) {   
        this.setState({ rating: nextValue });
    }

    handleSubmit = (data) => {    
        if (this.isUserAuthenticated()){  
            if (data.comment !== undefined && this.state.rating > 0 ){
                const rating = {     
                    film_id: this.state.movieId,
                    comment: data.comment,
                    rating: this.state.rating.toString()          
                }
                this.props.sendMovieReview(rating);
                window.scrollTo(0, 0);
                this.setState({rating: 0, error: ""});
            } else {
                this.setState({error: "Este obligatoriu să lăsați un rating și un comentariu"})
            } 
        } else {
            this.props.history.push(LOGIN_ROUTE);
        }    
    }

    getImageComment = () => {
        if (!isEmpty(this.props.userProfile)){
            return this.props.userProfile.picture !== "" ? API_URL + this.props.userProfile.picture : imgProfile
        } else {
            return imgProfile;
        }
    }

    render() {
        return (
            <div className={this.props.className + " comments"}>
                <h4 className="comment-border text-white">{ this.props.headline }</h4>
                {this.getComment()}
                { this.props.showInput ?
                    <div className="row p-3">
                        <div className="col-xl-1 col-lg-2 col-md-2 movie-comment-img">
                            <img alt={'Autor'} className="p-2 rounded-circle d-none d-sm-none d-md-none d-lg-block" src={ this.getImageComment()}/>
                        </div>
                        <div className="col-xl-11 col-lg-8 input-cmt">
                            <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={this.state.rating}
                                starColor={'#ffffff'}
                                emptyStarColor={'#4B6272'}
                                onStarClick={this.onStarClick.bind(this)}
                            />
                            <AddCommentForm 
                                onSubmit={this.handleSubmit}
                                placeholder= {"Lasă un rating și un comentariu..."} 
                            />
                            <p className="mt-3 text-white">{this.state.error}</p>
                        </div>
                    </div>
                : ''}
            </div>  
        );
    }
}


const mapStateToProps = state => ({
    userProfile: state.profile.userDetails
});

export default withRouter(connect(mapStateToProps,{sendMovieReview})(RatingComments));


// WEBPACK FOOTER //
// ./src/SHARED/components/ratingcomment/ratingcomment.component.js